import React from "react";
import CustomCardGridGeneral from "../../../../../components/CustomCardGridGeneral";
import CustomChip from "../../../../../components/CustomChip";
import {
    EmailSubsectionChip, FolderPerson,
    IconPersonDefaultV2,
    PhoneSubsectionChip
} from "../../../../../components/buttons/IconButtons";
import CustomTooltip from "../../../../../components/CustomTooltip";
import {status} from "../../../../../enums/statusEnum";
import {statusBorderColor, statusColor, statusFontColor} from "../../../../../enums/statusColorEnum";
import {CustomCheckbox} from "../../../../../components/CustomCheckbox";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import { VISITOR_VIEWS_FROM } from "../../Guard/Model/Model";
import { VisitorCardApp } from "../Functionality/VisitorCardApp";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer - IBL
 * @Email : kpozos@ibl.mx
 */

const VisitorCard = ({item, selectedList, setSelectedList, handleCheckboxChange, goUpdate, viewOrigin, setShowRequestAccessModal }) => {
    const { t } = useTranslation();
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const {permission} = useSelector((state) => state.authenticatioauthennSlice);
    const { renderVisitorButton } = VisitorCardApp({
        viewOrigin,
        setShowRequestAccessModal,
        item,
        goUpdate,
        DEV,
        permission,
        setSelectedList
    });

    return (
        <CustomCardGridGeneral
            selected={selectedList.includes(item?.id)}
            head={<>
                <div className="h-144px img-container img-background-primary-20 d-flex flex-column justify-content-center
                                align-items-center gap-2 flex-fill align-self-stretch position-relative overflow-hidden">
                    {item?.selfie && (
                        <img src={`data:image/png;base64,${item?.selfie}`} alt="profile" className="w-100 h-100 img-filter-background"/>
                    )}
                    <div className={"position-absolute gap-2 w-100 t-10px"}>
                        <div className={"pl-2 pr-20px"}>
                            <div className={"d-flex justify-content-between align-items-center"}>
                                {viewOrigin !== VISITOR_VIEWS_FROM.VISITOR_GUARD && (   <CustomCheckbox id={"cb_vtc_select_"+ item?.id}
                                                name={"selectVisitor"}
                                                checked={selectedList.includes(item?.id)}
                                                onChange={(e) => {
                                                    handleCheckboxChange({
                                                        target: { id: item?.id, checked: e.target.checked, value: e.target?.value },
                                                    });
                                                }}
                                                disableRipple={true}
                                />)}
                                <CustomChip legend={t(status[item?.statusId])}
                                            borderColor={statusBorderColor[item?.statusId]}
                                            fontColor={statusFontColor[item?.statusId]}
                                            background={statusColor[item?.statusId]}
                                            variant={'large'}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className={"h-60px position-relative"}>
                    {item?.selfie ?
                        <div className={"position-absolute t-50-l-50 t-0-center"}>
                            <img className={"w-120px h-120px image-card-grid"} src={`data:image/png;base64,${item?.selfie}`} alt='add' />
                        </div>
                        :
                        <div className={"position-absolute t-50-l-50 t-0-center"}>
                            <IconPersonDefaultV2/>
                        </div>
                    }
                </div>
            </>
            }
        >
            <div className="h-54px position-relative w-100">
                <div className={"position-absolute t-50-l-50 w-100"}>
                    <CustomTooltip
                        text={item.fullName}
                        classes={"ibl-h3 font-color-general-950 ibl-font-w-600 text-center text-ellipsis-2-rows"}
                        showIfTruncated={true}
                        placement={"top"}
                    />
                </div>
            </div>

            <div className={"border-bottom-shades-300-2px"}/>

            <div className="position-relative w-100 my-3">
                <div className={"position-absolute t-50-l-50 w-100"}>
                    <CustomTooltip
                        text={item.email}
                        classes={"fs-16px font-color-general-950 ibl-font-w-300 text-center text-ellipsis-1-row"}
                        showIfTruncated={true}
                        icon={<EmailSubsectionChip width={20} height={20} className={"mr-2"}/>}
                        placement={"top"}
                    />
                </div>
            </div>

            <div className="position-relative w-100 mb-3">
                <div className={"position-absolute t-50-l-50 w-100"}>
                    <CustomTooltip
                        text={item.phoneNumber || ""}
                        classes={"fs-16px font-color-general-950 ibl-font-w-300 text-center text-ellipsis-1-row"}
                        showIfTruncated={true}
                        icon={<PhoneSubsectionChip width={20} height={20} className={"mr-2"}/>}
                        placement={"top"}
                    />
                </div>
            </div>

            <div className="position-relative w-100 mb-3">
                <div className={"position-absolute t-50-l-50 w-100"}>
                    <CustomTooltip
                        text={item.documentId || t("no_identification")}
                        classes={"fs-16px font-color-general-950 ibl-font-w-300 text-center text-ellipsis-1-row"}
                        showIfTruncated={true}
                        icon={<FolderPerson width={20} height={20} className={"mr-2"}/>}
                        placement={"top"}
                    />
                </div>
            </div>
            {renderVisitorButton()}
        </CustomCardGridGeneral>
    );
};

export default VisitorCard;
